import TrashIcon from '@src/assets/images/common/icon/trash/TrashIcon';

const ChatDeletedMessage: React.FC = () => {
  return (
    <div className='relative flex flex-col gap-4 px-6 py-3'>
      <div className='flex items-center gap-3'>
        <div className='flex size-8 items-center justify-center rounded-full bg-gray-400'>
          <TrashIcon fillColor='#FFFFFF' />
        </div>
        <div className='min-w-0 whitespace-pre-wrap text-sm text-gray-400 md:pl-0'>
          <div className='pl-1 lg:pl-0'>このメッセージは削除されました。</div>
        </div>
      </div>
    </div>
  );
};

export default ChatDeletedMessage;
